import { TFunction } from 'i18next';
import { HumanModerationStatus } from '@/api/entities/moderation';
import { Repair } from '@/entities/repair';

export const getModerateText = (t: TFunction<undefined>, isModerateMandatory: boolean, moderationStatus: string) => {
  if (moderationStatus === HumanModerationStatus.MODERE && isModerateMandatory) {
    return t('inspection:moderationMandatoryDone');
  }
  if (moderationStatus === HumanModerationStatus.A_MODERER && isModerateMandatory) {
    return t('inspection:moderationMandatoryNotDone');
  }
  if (moderationStatus === HumanModerationStatus.MODERE && !isModerateMandatory) {
    return t('inspection:moderationOptionalDone');
  }
  if (moderationStatus === HumanModerationStatus.A_MODERER && !isModerateMandatory) {
    return t('inspection:moderationOptionalNotDone');
  }
  return '';
};

export const getRepairOptions = (
  dmgName: string,
  equipmentName: string,
  severity: number,
  repairData: Repair[]
): { name: string; estimatedCost: number }[] => {
  const repair = repairData?.find(
    item =>
      item.damageType === dmgName &&
      item.equipmentName === equipmentName
  );
  if (!repair) return [];
  const repairItem = repair.repairs.find(r => r.severity === Number(severity));
  if (!repairItem) return [];
  return repairItem.repairOptions.map(opt => ({
    name: opt.name,
    estimatedCost: opt.estimatedCost,
  }))};